/* eslint-disable no-debugger */
import { useEffect, useState } from 'react';
import useLscData from '../../../state/lsc/UseLscData';

const useLscMultiSelect = (filterIds) => {
  const { lscState, getLscs } = useLscData();
  const [options, setOptions] = useState([]);

  useEffect(() => {
    if (lscState.isLoading === false && lscState.isLoaded === false) {
      getLscs();
    } else if (lscState.isLoading === false && lscState.isLoaded === true) {
      const lscOptions = [];
      // const filterIdArray = filterIds && filterIds.length > 0 ? filterIds.split(',').map(id => parseInt(id)) : [];
      const filterIdArray = filterIds && filterIds.length > 0 ? filterIds.split(',').map(id => id) : [];

      for (const lsc of lscState.data) {
        if (lsc.orgUnitId.length > 0 && (filterIdArray.length === 0 || filterIdArray.includes(lsc.parentOrgUnitId))) {
          lscOptions.push({ id: lsc.orgUnitId, name: lsc.orgUnitName });
        }
      }

      setOptions(lscOptions);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lscState, filterIds]);

  return {
    lscState,
    options
  };
};

export default useLscMultiSelect;